var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"be-sidebar",on:{"mouseenter":_vm.mouseEnter,"mouseleave":_vm.mouseLeave}},[_vm._t("default",function(){return [_c('sidebar-header',[_c('h4',[_vm._v(" Sidebar Header")])]),_c('sidebar-menu')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }